import {
	useMutation,
	UseMutationResult,
	useQuery,
	UseQueryResult,
} from '@tanstack/react-query'

import { PaginatedResponse } from '@/core/api/dtos/common/types'
import { CreateCardPaymentIntentRequestDTO } from '@/core/api/dtos/request/payment/createCardPaymentIntent'
import { CreateSepaPaymentIntentRequestDTO } from '@/core/api/dtos/request/payment/createSepaPaymentIntent'
import { PaymentIntentResponseDTO } from '@/core/api/dtos/response/payment/paymentIntent'
import { PaymentMethod } from '@/core/api/entities/payment/paymentMethod'
import { PaymentMethodMapper } from '@/core/api/mappers/payment/paymentMethodMapper'
import { paymentService } from '@/core/api/services/paymentService'
import { DEFAULT_PARAMS } from '@/core/hooks/common'

export const useAvailablePaymentMethods = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseQueryResult<
	PaginatedResponse<PaymentMethod>,
	Error
> => {
	return useQuery({
		queryKey: ['availablePaymentMethods'],
		queryFn: () =>
			paymentService.getAvailablePaymentMethods(config).then((response) => {
				return {
					data: PaymentMethodMapper.toEntities(response.data.data),
					meta: response.data.meta,
				}
			}),
		...options,
	})
}

export const useCreatCardPaymentIntent = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseMutationResult<
	PaymentIntentResponseDTO,
	Error,
	CreateCardPaymentIntentRequestDTO,
	any
> => {
	return useMutation<
		PaymentIntentResponseDTO,
		Error,
		CreateCardPaymentIntentRequestDTO,
		any
	>({
		mutationFn: (data: CreateCardPaymentIntentRequestDTO) =>
			paymentService
				.createCardPaymentIntent(data, config)
				.then((response) => response.data.data),
		retry: 3,
		retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000), // 10 seconds max
		...options,
	})
}

export const useCreateSepaPaymentIntent = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseMutationResult<
	PaymentIntentResponseDTO,
	Error,
	CreateSepaPaymentIntentRequestDTO,
	any
> => {
	return useMutation<
		PaymentIntentResponseDTO,
		Error,
		CreateSepaPaymentIntentRequestDTO,
		any
	>({
		mutationFn: (data: CreateSepaPaymentIntentRequestDTO) =>
			paymentService
				.createSepaPaymentIntent(data, config)
				.then((response) => response.data.data),
		retry: 3,
		retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000), // 10 seconds max
		...options,
	})
}
